import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import ContributeButton from '../../../../../components/global/ContributeButton/ContributeButton';
import useOpenModal from '../../../../../hooks/useOpenModal';
import { getThumbBySize } from '../../../../../util/photo';
import { IMAGE_SIZE_CODE } from '../../../../../constants/image-size-codes';
import { isAlbumOwner } from '../../../../../util/account';
import ListingCardTemplate from '../../../../pro/components/ListingCardTemplate';
import Button from '../../../../../components/global/Button';
import { CONTRIBUTOR_SHARE_MODAL } from '../../../../../constants/modals';
import { useViewPermission } from '../../../../pro/services/contributors';

const propTypes = {
  linkTo: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onClick: PropTypes.func,
  user: PropTypes.shape({
    id: PropTypes.string,
  }),
  album: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }),
  className: PropTypes.string,
  thumbnails: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string.isRequired,
    }).isRequired,
  ),
  thumbnailActions: PropTypes.node,
  title: PropTypes.string,
};

const WebGalleryGroupVideoListingCard = ({
  linkTo,
  onClick,
  user,
  album,
  thumbnails,
  className,
  isDisabled,
  thumbnailActions,
  title,
}) => {
  const { isAllowed: isAllowedToView } = useViewPermission({
    entityId: album?.id,
  });
  const openModal = useOpenModal();
  const disabled = isDisabled || !isAllowedToView;
  const thumbnailUrl = getThumbBySize(
    thumbnails,
    IMAGE_SIZE_CODE.MEDIUM2X,
    // Important for when using local cache
    true,
  )?.url;
  const classes = classNames({
    'album-card': true,
    'video-guestbook-card': true,
    [className]: !!className,
  });

  const isOwner = isAlbumOwner(user, album);

  return (
    <ListingCardTemplate
      className={classes}
      linkTo={linkTo}
      onClick={onClick}
      title={title ?? album?.name}
      thumbnailUrl={thumbnailUrl}
      isDisabled={disabled}
      thumbnailActions={thumbnailActions}
      note={
        <>
          {isOwner && <p>Gather 30-second video messages from others</p>}
          {!isOwner && <p>View others&rsquo; well wishes and add yours!</p>}

          <div className="listing-card-template-cover-null-state-actions-buttons">
            {!isOwner && (
              <ContributeButton
                className="text-uppercase"
                btnStyle="primary"
                btnOutline
                btnSize="xs"
                albumId={album?.id}
              >
                Add Video
              </ContributeButton>
            )}
            {isOwner && (
              <Button
                className="text-uppercase"
                btnStyle="primary"
                btnOutline
                btnSize="xs"
                onClick={event => {
                  event.preventDefault();
                  openModal(CONTRIBUTOR_SHARE_MODAL);
                }}
              >
                Invite
              </Button>
            )}
          </div>
        </>
      }
    />
  );
};

WebGalleryGroupVideoListingCard.propTypes = propTypes;

export default WebGalleryGroupVideoListingCard;
